import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CutsceneTemplat from '../Components/Layout/CutsceneTemplate';

import Commander from '../Assets/Imgs/Commander.png';
import Mike from '../Assets/Imgs/Mike.png';
import Btn from '../Components/Common/Btn';

import Pause from '../Assets/Icons/Pause.svg'
import PauseMenu from '../Components/Layout/PauseMenu';

const FixCutscene = () => {

    const [currentLine, setCurrentLine] = useState(0)
    const [isPaused, setIsPaused] = useState(false);

    const navigate = useNavigate();

    const dialogue = [
        {
            img: Mike, text: 'What’s this??', DName: 'Private Mike'
        },

        {
            img: Mike, text: 'Seems like a mutlitool of some sort. It’s definitely seen better days! ', DName: 'Private Mike'
        },

        {
            img: Commander, text: `If you can find a way to get that thing working again it might help you.`, DName: 'Commander'
        },
        {
            img: Mike, text: 'I’ll see what i can do', DName: 'Private Mike'
        }
    ]

    const handleNextDialogue = () => {
        if (currentLine < dialogue.length - 1) {
            setCurrentLine(prevStep => prevStep + 1);
        } else {
            navigate('/L2');
        }
    };

    const currentDialogue = dialogue[currentLine];
    console.log(dialogue[0])

    return ( 
        <main className='IntroCutsceneMain'>

            <Btn BtnIcon={Pause} BtnStyle="PauseBtn" onClick={() => setIsPaused(true)}/>
            
            <CutsceneTemplat TemplateClass='FixTemplate' DialogueImg={currentDialogue.img} DialogueName={currentDialogue.DName} DialogueP={currentDialogue.text} NextBtnChange={handleNextDialogue}/>

            {isPaused && <PauseMenu ResumeClick={()=>setIsPaused(false)}/>}
        </main>
     );
}
 
export default FixCutscene;